export const userToText = (user) => (user ? `${user.firstName} ${user.lastName}` : '');
export const mentionRegexp = /@[0-9]+/;
